<template>
  <div class="box box--gray">
    <h4 class="box__title">{{ in18['page_coupon_code_title'] }}</h4>
    <form class="cart__discount-form">
      <input
          v-model="couponCode"
          class="cart__discount-form-input"
          type="text"
          :placeholder="in18['page_coupon_code_placeholder']"
          :disabled="couponApplied"
      />
      <button
          v-if="!couponApplied"
          class="btn btn--red btn--sm mb-0"
          type="submit"
          @click.prevent="applyCoupon"
          :disabled="inProgress || !this.couponCode"
      >
        {{ in18['page_coupon_apply_code_btn'] }}
      </button>
      <button
          v-else
          class="btn btn--red btn--sm mb-0"
          type="button"
          @click.prevent="removeCoupon"
          :disabled="inProgress"
      >
        {{ in18['page_coupon_remove_code_btn'] }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    cart:       {
      type: Object,
    },
    in18:       {
      type: Object,
    },
    inProgress: {
      type: Boolean,
    },
  },

  emits: [
    'update-cart',
    'update-in-progress'
  ],

  data() {
    return {
      couponCode:    this.cart.coupon ? this.cart.coupon.code : '',
      couponApplied: !!this.cart.coupon,
    };
  },

  methods: {

    /**
     * Apply the entered coupon code to the cart.
     */
    applyCoupon() {

      if (this.inProgress || !this.couponCode) {
        return;
      }

      this.$emit('update-in-progress', true);

      axios
          .post('/api/coupon/apply', {
            code: this.couponCode,
          })
          .then((response) => {
            let cart = response.data.cart;
            window.toastr.success(response.data.message);
            this.$emit('update-cart', cart);
            this.couponCode = cart.coupon ? cart.coupon.code : '';
            this.couponApplied = true;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            this.couponCode = '';
          })
          .finally(() => {
            this.$emit('update-in-progress', false);
          });
    },

    /**
     * Remove the applied coupon code from the cart.
     */
    removeCoupon() {

      if (confirm(this.in18['page_coupon_remove_confirm']) !== true) {
        return;
      }

      if (this.inProgress || !this.couponCode) {
        return;
      }

      this.$emit('update-in-progress', true);

      axios
          .post('/api/coupon/remove/')
          .then((response) => {
            console.log(response.data.cart);
            window.toastr.success(response.data.message);
            this.$emit('update-cart', response.data.cart);
            this.couponCode = '';
            this.couponApplied = false;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            console.log(error.response);
          })
          .finally(() => {
            this.$emit('update-in-progress', false);
          });
    },
  },
};
</script>
